import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import "./firebase";
import router from "./router";
import store from "./store";
import "./styles/tailwind.scss";

Vue.config.productionTip = false;

Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
